<script setup>
import {defineProps} from 'vue';

defineProps({
    title: String,    
})

</script>

<template>
<div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="DetailModal" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="DetailModal">{{ title }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="card-body">
                        <div class="row">
                            <slot></slot>
                        </div>
                    </div>                           
                </div>
            </div>
        </div>
    </div>
</div>
</template>